import React, { useState } from 'react';
import './Time.css';
import TimePicker from 'rc-time-picker';
import Calendar from 'react-calendar';
import './Calendar.css';
import { useSelector } from 'react-redux';
import checkIcon from '../../assets/images/circle_check.svg';
import moment from 'moment';
import { toast } from 'react-toastify';
import closeIcon from '../../assets/images/closebtn.svg';
import {formatDateNew, formatDateNewMMMDDYYYY} from '../../utils/redableDateTime.js';
import { Post } from '../../Api/ApiMethods.js';
import { 
    takeSiteTourUrk
 } from '../../Routes/ApiRoutes';


export default function TakeTour(props) {
    const token = useSelector((state) => state.auth.isSignedIn);
    const [finalize, setFinalize] = useState(false);
    const [showCal, setShowCAl] = useState(true);
    const [showTime, setShowTime] = useState(false);

    const [dateValue, setDateVelue] = useState(new Date());
    const [timeValue, setTimeVelue] = useState(moment(new Date()));
    

    function TourFinalPopUp() {
        return(
            <div className='calender'>
                <div class="generate-popup">
                    <span onClick={() => props.hideTour()}><img src={closeIcon}/></span>
                    <div class="img-circle">
                        <img src={checkIcon} />
                        <p>Your tour for parking space {props.data && props.data.slotNumber} has been booked for {formatDateNewMMMDDYYYY(dateValue)} at {timeValue.format('h:mm a')}. A one time passcode for security gate will be sent to your email.</p>
                    </div>
                </div>
            </div>
        )
    }

    function TourPanel() {
        return(
            <>

            <div className='calender'>
                <div className='header'>
                    <div className='box'>
                        <span style={{cursor: 'pointer'}} onClick={() => props.hideTour()}><img src={closeIcon}/></span>
                        <span className='marginLeft'>Book your one hour tour</span> 
                    </div>
                </div>
                <div className='body'>
                    {showCal &&   <Calendar
                            prev2Label={null}
                            next2Label={null}
                            minDate={moment().toDate()}
                            minDetail="month"
                            maxDetail="month"
                            defaultView="month"
                            onChange={(e) =>  setDateVelue(e)}
                            value={dateValue}
                        /> }
                        {showTime &&
                            <>
                                <div>
                                    <label className='calTimeLabel'>Select time </label>
                                    <TimePicker
                                        className='calInputTime'
                                        showSecond={false}
                                        value={timeValue}
                                        className="xxx"
                                        onChange={(e) => {
                                            var t = e.format('h:mm a');
                                            var arr = t.toString().split(':');
                                            var arr2 = arr[1].split(' ');

                                            if(e){
                                                var hour = arr[0];
                                                var min = arr2[0];
                                                var ap = arr2[1];

                                                if(ap === 'am'){
                                                    if(hour <= 9 || hour >= 12){
                                                        toast.error('Tour time should be between 10 AM and 6PM')
                                                    }
                                                }
                                                if(ap === 'pm'){
                                                    if(hour >= 6 && hour < 12){
                                                        toast.error('Tour time should be between 10 AM and 6PM')
                                                    }
                                                }
                                                console.log(e);
                                                setTimeVelue(e)
                                            }
                                        }}
                                        format='h:mm a'
                                        use12Hours
                                        inputReadOnly
                                    />
                                </div>
                            </>
                        }
                </div>
                <div className='footer'>
                    <div class="buttons-wrapper">
                        <div class="comman-btn">
                            <button onClick={() => handleButton()}>{showCal ? 'Next' : 'Done'}</button>
                        </div>
                    </div>
                </div>
            </div>
            </>
        )
    }

    function bookTourHour (){
    let data = {
            "slot_id": props.data.id,
            "tour_date": formatDateNew(dateValue),
            "tour_time": timeValue.format('HH:mm')
          }
        try {
            Post(takeSiteTourUrk, token, data)
            .then(response => {
                if(response.status === 200){
                    toast.success(response.message);
                    setFinalize(true);
                }
            })
            .catch(error => {
                props.hideTour();
                toast.error(error.error)
            })
          }catch (error) {
            props.hideTour();
            toast.error(error.error)
          }
    }

    const handleButton = () => {
        if(showCal === true){
            setShowCAl(false);
            setShowTime(true);
        }
        else if(showTime === true){

            let t = timeValue.format('h:mm a');

            let arr = t.toString().split(':');

            let arr2 = arr[1].split(' ');

                let hour = arr[0];
                let min = arr2[0];
                let ap = arr2[1];

                let token = false;
                if(ap === 'am'){
                    if(hour <= 9 || hour >= 12){
                        toast.error('Tour time should be between 10 AM and 6PM');
                        token = false;
                    }else{
                        token = true
                    }
                }
                if(ap === 'pm'){
                    if(hour >= 6 && hour < 12){
                        toast.error('Tour time should be between 10 AM and 6PM');
                        token = false;
                    }else{
                        token = true;
                    }
                }
                if(token){
                    bookTourHour();
                }
        }
    }

    return (
        <>
            {finalize ? <TourFinalPopUp /> : <TourPanel /> }
        </>
    )
}
